import { render, staticRenderFns } from "./AbsenceToggleButton.vue?vue&type=template&id=3cd1312a"
import script from "./AbsenceToggleButton.vue?vue&type=script&lang=js"
export * from "./AbsenceToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports